export default __webpack_public_path__ + "static/media/infill.64a17af2.svg";